export default "__VITE_ASSET__f554f7d8__"